import React from 'react'
import { Box, Skeleton, Card, Text, Divider } from '@mantine/core';
import { currencyFormat } from 'simple-currency-format';
import BoxBank from './BoxBanks';
import { useDashboardStore } from '../../store/useDashboardStore';

const Banks = () =>
{
  const { banks } = useDashboardStore();
  const formatCurrency = (amount) => currencyFormat(amount, 'es-MX', 'MXN', 0);
  
  const renderBanks = (banks) =>
  {
    if (!Array.isArray(banks) || banks.length === 0) {
      return Array.from({ length: 5 }).map((_, i) => (
        <Skeleton key={i} height={40} radius="xs" mb="xs" />
      ));
    }

    const totalAmount = banks.reduce((acc, curr) => acc + curr.amount, 0);
    const sortedBanks = [...banks].sort((a, b) => b.amount - a.amount);

    return (
      <Card withBorder padding="md" radius="xs" shadow="sm">
        <Text size="xs" fw={900} tt="uppercase" c="dimmed" mb="md" style={{ letterSpacing: '1px' }}>
          Distribución por Banco
        </Text>
        
        <Box>
          {sortedBanks.map((item, index) => (
            <BoxBank
              key={ index }
              title={ item.bank === "undefined" ? "Desconocido" : item.bank }
              value={ formatCurrency(item.amount) }
              percentage={ totalAmount > 0 ? (item.amount / totalAmount) * 100 : 0 }
            />
          ))}
        </Box>

        <Divider my="sm" variant="dashed" />
        
        <Box style={{ textAlign: 'right' }}>
          <Text size="xs" c="dimmed" tt="uppercase">Total General</Text>
          <Text size="md" fw={900} style={{ fontFamily: 'var(--mantine-font-family-monospace)' }}>
            { currencyFormat(totalAmount, 'es-MX', 'MXN', 2) }
          </Text>
        </Box>
      </Card>
    );
  };

  return renderBanks(banks);
}

export default Banks
